import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { getAssistantTypeApi, getFrontEndSettings } from "../../api";
import { checkAndHandleAuth } from "../../services/authService";

type AuthStatus = "pending" | "authenticated" | "redirecting";

const PrivateRoute = () => {
  const [status, setStatus] = useState<AuthStatus>("pending");
  const [maintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
    Promise.all([getFrontEndSettings(), getAssistantTypeApi()]).then(
      ([settings, assistantSettings]) => {
        if (
          settings.error instanceof Error &&
          settings.error.message === "Authentication Required"
        ) {
          setStatus("redirecting");
          checkAndHandleAuth();
          return;
        }

        if (assistantSettings?.show_maintenance_page) {
          setMaintenanceMode(assistantSettings.show_maintenance_page);
        }

        setStatus("authenticated");
      },
    );
  }, []);

  if (status === "pending" || status === "redirecting") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner size={SpinnerSize.large} />
      </div>
    );
  }

  if (maintenanceMode) {
    return <Navigate to="/maintenance" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
